<template>
  <div class="dialog-edit-user-app-wrapper">
    <el-dialog
      :title="getTitle()"
      width="50%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">

        <el-form-item label="过期时间" prop="expire_at">
          <el-date-picker
            v-model="form.expire_at"
            type="datetime"
            style="width: 100%;"
            placeholder="选择应用过期时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item
          v-for="(extend, index) in form.extend"
          :key="'extend' + index"
          :label="'应用扩展字段' + index">

          <el-select
            style="width: 40%; margin-bottom: 10px;"
            v-model="extend.name"
            @change="onExtendChange(index, $event)">
            <el-option
              v-for="extend in appExtendParamList"
              :key="extend.extend_param_id"
              :value="extend.extend_param_name" >
              {{ extend.extend_param_name }}
            </el-option>
          </el-select>

          <el-input
            style="width: 40%; margin-left: 30px;"
            v-model="extend.value"
            placeholder="请输入扩展字段的值" />

          <el-input
            style="width: 40%;"
            v-model="extend.remarks"
            placeholder="请输入扩展字段的备注" />

          <el-button
            type="danger"
            size="medium"
            style="margin-left: 30px;"
            @click="onDeleteExtendClick(index)">删除</el-button>
        </el-form-item>

        <el-form-item label="状态" prop="status" >
          <el-radio v-model="form.status" :label="0">可用</el-radio>
          <el-radio v-model="form.status" :label="1">禁用</el-radio>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button type="info" @click="onAddExtendClick">添加扩展字段</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogEditUserApp',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    editingUserApp: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        expire_at: [
          { required: true, message: '请选择过期时间', trigger: 'change' }
        ]
      },
      form: {
        userid: 0,
        user_app_id: 0,
        extend: [
          {
            name: '',
            value: '',
            remarks: ''
          }
        ],
        expire_at: '',
        status: 0
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appExtendParamList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'getAppExtendParams',
      'editUserApp'
    ]),

    getTitle () {
      if (JSON.stringify(this.editingUserApp) === '{}') {
        return '修改用户应用'
      }
      const username = this.editingUserApp.user_detail.username || '未知'
      const moduleName = this.editingUserApp.app_store_detail.app_module_name || '未知'
      return `修改用户应用 (${username} - ${moduleName})`
    },

    onExtendChange (index, selected) {
      this.appExtendParamList.forEach(extend => {
        if (extend.extend_param_name === selected) {
          this.form.extend[index].remarks = extend.remarks
        }
      })
    },
    onDeleteExtendClick (index) {
      this.form.extend.splice(index, 1)
    },
    onAddExtendClick () {
      if (this.appExtendParamList.length === 0) {
        this.$message({
          type: 'error',
          message: '当前应用不支持扩展字段'
        })
        return
      } else if (this.form.extend.length >= this.appExtendParamList.length) {
        this.$message({
          type: 'error',
          message: '已添加当前应用的所有扩展字段'
        })
        return
      }
      const addingExtend = this.appExtendParamList[this.form.extend.length]
      this.form.extend.push({
        name: addingExtend.extend_param_name,
        value: '',
        remarks: addingExtend.remarks
      })
    },

    // 整理表单，验证数据
    cleanFormAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      let isValid = true
      clean.extend.forEach(extend => {
        if (extend.value === '' || extend.remarks === '') {
          isValid = false
        }
      })

      if (!isValid) {
        this.$message({
          type: 'error',
          message: '扩展字段的值和备注不能为空！'
        })
        return
      }
      // 提交表单
      this.performSubmit(clean)
    },
    async performSubmit (cleanForm) {
      try {
        await this.editUserApp(cleanForm)

        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '修改用户应用失败'
        })
        console.log(err)
      }
    },

    onFormSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.cleanFormAndSubmit()
        }
      })
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },

    async fetchAppExtend () {
      try {
        await this.getAppExtendParams({
          page: 1,
          pageSize: 9999,
          condition: {
            app_store_id: this.editingUserApp.app_store_id
          }
        })
      } catch (err) {
        console.log(err)

        this.$message({
          type: 'error',
          message: '获取扩展字段列表失败'
        })
      }
    },

    onDialogOpen () {
      this.form.userid = this.editingUserApp.userid
      this.form.user_app_id = this.editingUserApp.user_app_id
      this.form.extend = this.editingUserApp.extend
      this.form.expire_at = this.editingUserApp.expire_at || '2120-01-22T03:17:46.668Z'
      this.form.status = this.editingUserApp.status || 0

      this.fetchAppExtend()
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-edit-user-app-wrapper {
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogEditUserApp.vue